import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close.svg'
import _imports_1 from '@/assets/send.svg'


const _withScopeId = n => (_pushScopeId("data-v-65ac3923"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chat-dialog-container"
}
const _hoisted_2 = { class: "chat-dialog" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end","padding":"10px"} }
const _hoisted_4 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","padding":"2rem 8rem"} }
const _hoisted_5 = { style: {"border-radius":"17px","display":"flex","flex-direction":"column","margin-right":"3rem","border":"1px solid rgb(142, 142, 142)","height":"700px","width":"500px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"1px solid rgb(142, 142, 142)","padding":"14px 0","display":"flex","flex-direction":"column","justify-content":"center"} }, " Customer Chat Experience ", -1))
const _hoisted_7 = { style: {"color":"white","font-weight":"500","background":"rgb(85, 88, 254)","border-radius":"17px","padding":"10px","margin-right":"10px","max-width":"300px","word-break":"break-word !important","text-align":"left"} }
const _hoisted_8 = { style: {"color":"white","background":"rgb(110, 110, 110)","border-radius":"17px","padding":"10px","margin-left":"10px","max-width":"300px","word-break":"break-word !important","text-align":"left"} }
const _hoisted_9 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","justify-content":"flex-start","margin":"10px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"white","background":"rgb(110, 110, 110)","border-radius":"17px","padding":"10px","margin-left":"10px","max-width":"300px","word-break":"break-all"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "is-typing" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "jump1" }),
    /*#__PURE__*/_createElementVNode("div", { class: "jump2" }),
    /*#__PURE__*/_createElementVNode("div", { class: "jump3" })
  ])
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { style: {"display":"flex","border-top":"1px solid rgb(142, 142, 142)"} }
const _hoisted_13 = ["onKeyup"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { style: {"background":"rgb(225, 225, 225)","display":"flex","flex-direction":"column","border":"1px solid black","height":"700px","width":"500px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"14px 0","border-bottom":"1px solid black","display":"flex","flex-direction":"column","justify-content":"center"} }, "EagleTrace Analysis", -1))
const _hoisted_18 = ["innerHTML"]

import { useAuth0 } from '@auth0/auth0-vue';
import axios from 'axios';
import { Ref, computed, nextTick, ref, watch } from 'vue'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatDialog',
  setup(__props) {

const { user } = useAuth0()
const store = useStore()

const parsedOutput = ref("")


const showDialog = computed({
    get: () => store.getters.showChatDialog,
    set: (value) => store.commit('SET_SHOW_CHAT_DIALOG', value)
})

const text = ref("")

const messages: Ref<Array<any>> = ref([])
const realMessages: Ref<Array<any>> = ref([])

const loading = ref(false)
const chat: Ref<HTMLElement | undefined | null> = ref(null)


const isJSON = (str: string) => {
  try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

const send = async () => {

    if (text.value !== "")
    {
        messages.value.push({
            "role": "user",
            "content": text.value
        })
        realMessages.value.push({
            "role": "user",
            "content": text.value
        })
    }



    text.value = ""

    loading.value = true
    
    nextTick(() => {
        chat!.value!.scrollTop = chat!.value!.lastElementChild!.offsetTop
    })


    const response = await axios.post(`${process.env.VUE_APP_BACKEND_URI}/chat`, {
        messages: realMessages.value,
        email: user.value.email
    }) 


    setTimeout(() => {
        loading.value = false

        const content: string = response.data.content
        const function_call = response.data.function_call

        console.log(content);
        

        if (content && isJSON(content))
        {
            const parsed = JSON.parse(content)
            realMessages.value.push({
                "role": "assistant",
                "content": content
            })
            for (const key in parsed) {
                if (key.includes("EagleChatbot")) {
                    if (parsed[key])
                        messages.value.push({
                            "role": "assistant",
                            "content": parsed[key]
                        })
                    continue;
                }

                if (key.includes("EagleTrace")) {
                    const element = parsed[key];
                    parsedOutput.value += key + ": " + element + ",<br>"
                }
            }
            parsedOutput.value += "<br>" 
        }

        else if (content) {

            const answerRegex = /(:?"EagleChatbot Next Question": "(.*)")|(:?EagleChatbot Next Question: (\w+))\n/g;
            const scamScoreRegex = /(:?"EagleTrace Scam Score": "(.*)")|(:?EagleTrace Scam Score: ([0-9]*))/g;
            const confidenceRegex = /(:?"EagleTrace Confidence": "(.*)")|(:?EagleTrace Confidence: ([0-9]*))/g;
            const reasonRegex = /(:?"EagleTrace Reason": "(.*)")|(:?EagleTrace Reason: (.*)\n)$/g;
            const continueRegex = /(:?"Continue": "(.*)")|(:?Continue: (.*\s))/g;
            
            const answerMatch = answerRegex.exec(content)
            const scamScoreMatch = scamScoreRegex.exec(content)
            const confidenceMatch = confidenceRegex.exec(content)
            const reasonMatch = reasonRegex.exec(content)
            const continueMatch = continueRegex.exec(content)

            if (scamScoreMatch) {
                if (scamScoreMatch[2])
                    parsedOutput.value += "Scam Score: " + scamScoreMatch[2] + ",<br>"
                else if (scamScoreMatch[4])
                    parsedOutput.value += "Scam Score: " + scamScoreMatch[4] + ",<br>"
            }

            if (confidenceMatch) {
                if (confidenceMatch[2])
                    parsedOutput.value += "Confidence: " + confidenceMatch[2] + ",<br>"
                else if (confidenceMatch[4])
                    parsedOutput.value += "Confidence: " + confidenceMatch[4] + ",<br>"
            }

            if (reasonMatch) {
                if (reasonMatch[2])
                    parsedOutput.value += "Reason: " + reasonMatch[2] + ",<br>"
                else if (reasonMatch[4])
                    parsedOutput.value += "Reason: " + reasonMatch[4] + ",<br>"
            }

            if (continueMatch) {
                if (continueMatch[2])
                    parsedOutput.value += "Continue: " + continueMatch[2] + ",<br>"
                else if (continueMatch[4])
                    parsedOutput.value += "Continue: " + continueMatch[4] + ",<br>"              
            }

            if (answerMatch) {
                if (answerMatch[2])
                    messages.value.push({
                        "role": "assistant",
                        "content": answerMatch[2]
                    })
                else if (answerMatch[4])
                    messages.value.push({
                        "role": "assistant",
                        "content": answerMatch[4]
                    })
            }
            else {
                messages.value.push({
                    "role": "assistant",
                    "content": response.data.content
                })
            }

        } else if (!content && function_call) {
            const args = JSON.parse(function_call["arguments"])
            console.log(args);

            for (const key in args) {
                if (key === "EagleChatbot Next Question") continue;

                if (Object.prototype.hasOwnProperty.call(args, key)) {
                    const element = args[key];
                    console.log(key, element);
                    parsedOutput.value += key + ": " + element + "\n"
                }
            }
            

            messages.value.push({
                "role": "assistant",
                "content": args["EagleChatbot Next Question"]
            })


            
        }
        else if (!content && !function_call) {
            messages.value.push({
                "role": "assistant",
                "content": "Sorry, I didn't understand that. Could you please rephrase?"
            })
        }





    
        
        nextTick(() => {
            chat!.value!.scrollTop = chat!.value!.lastElementChild!.offsetTop
        })
        
    }, 300);



    
    
}

watch(showDialog, async (value) => {
    if (value === false) {
        messages.value = []
        parsedOutput.value = ""
    }
    else {
        send()
    }

})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (showDialog.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "chat-background",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _imports_0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false)),
                  style: {"cursor":"pointer","width":"38px"}
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", {
                    ref_key: "chat",
                    ref: chat,
                    style: {"flex-grow":"1","overflow-y":"scroll"}
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        style: {"display":"flex","flex-direction":"column","margin":"10px"},
                        key: index
                      }, [
                        (message.role === 'user')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 'user' + index,
                              style: {"display":"flex","flex-direction":"row","justify-content":"flex-end"}
                            }, [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(message.content), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 'assistant' + index,
                              style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"}
                            }, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(message.content), 1)
                            ]))
                      ]))
                    }), 128)),
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                      : _createCommentVNode("", true)
                  ], 512),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      onKeyup: _withKeys(send, ["enter"]),
                      class: "send-input",
                      placeholder: "Type a reply",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((text).value = $event)),
                      type: "text",
                      style: {"width":"100%"}
                    }, null, 40, _hoisted_13), [
                      [_vModelText, text.value]
                    ]),
                    _createElementVNode("button", {
                      onClick: send,
                      class: "send-button"
                    }, _hoisted_15)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", {
                    style: {"flex-grow":"1","text-align":"left","word-break":"break-word !important","overflow-y":"scroll","overflow-x":"hidden","padding":"1rem"},
                    innerHTML: parsedOutput.value
                  }, null, 8, _hoisted_18)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})